import React from 'react';
import { CommonPageProps } from 'src/screens/product-browse/common-page';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function ProductEmptyScreen(props: CommonPageProps) {
  return <div>&nbsp;</div>;
}
